export interface IFormData {
    [name: string]: IInputType;
}

export enum FormInput {
    Name = "Name",
    Surname = "Surname",
    PersonalCode = "PersonalCode",
    Address = "Address",
    Phone = "Phone",
    Email = "Email",
    Notes = "Notes",
    Company = "Company",
    RegistrationNumber = "RegistrationNumber",
    ContactPerson = "ContactPerson"
}

export interface IInputType {
    label: string;
    name: string;
    type: string;
    autocomplete?: string;
    required?: boolean;
    validationFn?: (value) => boolean;
    validationErrorMessage?: string;
}

export const formField: IFormData = {
    Name: {
        label: "Vārds",
        name: FormInput.Name,
        type: "text",
        autocomplete: "name",
        required: true
    },
    Surname: {
        label: "Uzvārds",
        name: FormInput.Surname,
        type: "text",
        autocomplete: "family-name",
        required: true
    },
    PersonalCode: {
        label: "Personas kods",
        name: FormInput.PersonalCode,
        type: "text",
        required: true,
        validationFn: (value): boolean => {
            //@ts-ignore
            const result = window.PersonCodeValidator(value.replace(/[^0-9]/g, ""));
            result.error && console.log("pk validation", result.error);
            return result.isSuccess;
        },
        validationErrorMessage: "Kļūdains personas kods"
    },
    Address: {
        label: "Adrese",
        name: FormInput.Address,
        type: "text",
        autocomplete: "street-address",
        required: true,
        validationFn: (value): boolean => value.length <= 250,
        validationErrorMessage: "Pārsniedz 250 zīmes"
    },
    Phone: {
        label: "Telefona numurs",
        name: FormInput.Phone,
        type: "tel",
        autocomplete: "tel",
        required: true,
        validationFn: (value): boolean => (value.match(/^\d{8,11}$/) ? true : false), // only digits, 8-11 symbols
        validationErrorMessage: "Kļūdains telefona numurs"
    },
    Email: {
        label: "E-pasts",
        name: FormInput.Email,
        type: "text",
        autocomplete: "email",
        required: true,
        validationFn: (value): boolean => (value.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/) ? true : false),
        validationErrorMessage: "Kļūdains epasts"
    },
    Notes: {
        label: "Piezīmes",
        name: FormInput.Notes,
        type: "text"
    },
    Company: {
        label: "Nosaukums",
        name: FormInput.Company,
        type: "text",
        autocomplete: "organization",
        required: true
    },
    RegistrationNumber: {
        label: "Reģistrācijas numurs",
        name: FormInput.RegistrationNumber,
        type: "text",
        required: true,
        validationFn: (value): boolean => {
            return value.length === 9 || value.length === 11;
        },
        validationErrorMessage: "Kļūdains reģistrācijas numurs"
    },
    ContactPerson: {
        label: "Kontaktpersona",
        name: FormInput.ContactPerson,
        type: "text",
        required: true
    }
};
